module.exports = "/images/cover-9.jpg";